<template>
    <div id="PromotionalCode" class="menu-component pb-5">
        <div class="row m-0 text-left">
            <div class="col-12 mb-3">
                <h4>Código promocional</h4>
            </div>
            <div class="col-12" v-if="checkCode">
                <div class="row">
                    <div class="col-12">
                        <label for="" class="p-0">Digite seu cupom</label>
                    </div>
                    <div class="col-9">
                        <input type="text"  class="form-control" v-model="inputCode" @keyup.enter="searchCode">
                    </div>
                    <div class="col-3 pl-0">
                        <button v-if="!searching" @click="searchCode" class="btn btn-primario btn-block"><i class="fas fa-search"></i></button>
                        <button v-else disabled class="btn btn-primario btn-block"><i class="fas fa-spinner fa-spin"></i></button>
                    </div>
                    <div class="col-12 mt-2" v-if="fail === true">
                        O código <strong>{{ invalidCode }}</strong> é inválido.
                    </div>
                    <div class="col-12 mt-2" v-if="fail === false && successCode != ''">
                        <p>O código <strong>{{ successCode }}</strong> te dá um desconto de <strong>R$ {{ discount }}</strong> no valor da adesão do site!</p>
                    </div>
                    <div class="col-8" v-if="fail === false && successCode != ''">
                        <p><button class="btn btn-primario btn-block" @click="useCode">Utilizar {{ successCode }}</button></p>
                    </div>
                </div>
            </div>
            <div class="col-12" v-else>
                <p class="mb-1">Seu código promocional atual é:</p>
                <p><strong>{{$store.state.user.usingCode}}</strong></p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "PromotionalCode",
    data(){
        return{
            inputCode: '',
            fail: false,
            invalidCode: '',
            successCode: '',
            discount: 0,
            searching: false,
            applied: false
        }
    },
    props:{
        saveData: {type: Boolean},
    },
    computed:{
        checkCode(){
            if(this.$store.state.user.usingCode != null){
                return false
            }else{
                return true
            }
        }
    },
    methods:{
        searchCode(){
            this.searching = true;
            let code = this.inputCode;
            let token = this.$session.get("jwt");
            this.fail = false;
            this.invalidCode = '';
            axios({
                method: "get",
                url: process.env.ROOT_API+'/api/code/'+code,
                headers: {
                    Authorization: "Bearer "+token,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if(response.data.status == '1'){
                    this.invalidCode = '';
                    this.fail = false;
                    this.successCode = code;
                    this.discount = response.data.discount;
                }
                else{
                    this.invalidCode = code;
                    this.fail = true;
                    this.successCode = '';
                    this.discount = 0;
                }
                this.searching = false;
            })
        },
        useCode(){
            this.invalidCode = '';
            let code = this.successCode;
            let token = this.$session.get("jwt");
            this.$store.commit("UPDATE_DISCOUNT_CODE", code);
            this.applied = true;
            axios({
                method: "post",
                url: process.env.ROOT_API+'/api/code/'+code+'/user/link',
                headers: {
                    Authorization: "Bearer "+token,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if(response.data.status == '1'){
                    this.$store.commit("UPDATE_DISCOUNT_CODE", code);
                }
                else{
                    console.log('nao');
                }
                this.$emit('updateMenuOption');
            })
        },
    },
}
</script>

<style scoped>
.form-control{
    background-color: transparent;
}
.copy-button{
    cursor: pointer;
    border-radius: 50%;
    color: #777;
    font-size: 1.2rem;
}
.copy-button:hover{
    color: var(--main-color);
}
.user-link{
    color: var(--main-color);
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    width: 100%;
    flex-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.total-ganhos, .total-link{
    color: #777;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/PromotionalCode.vue